module.exports = __webpack_public_path__ + "img/zanwucheliang.cfa56089.png";